import appStore from '@/store'
import request from '@/utils/request'
import {
    SERVICE_GET_PICTURE_CAPTCHA,
    SERVICE_SEND_SMS_CAPTCHA,
} from '@/constants/apis'

/**
 * 跳转到登录页
 */
export function gotoLoginPage() {
    window.location = '/#/index/home'
}

/**
 * 用户登出
 */
export function logout() {
    appStore.setMessageFlag(true).setLoginUser(null).setToken(null)
    gotoLoginPage()
}

/**
 * 获取图片验证码
 */
export function getPictureCaptcha() {
    return request({ url: SERVICE_GET_PICTURE_CAPTCHA, params: { ts: Date.now() }, method: 'get' }).then(res => {
        const data = res.data || {}
        return {
            unique_code: data.token,
            picture: data.captcha
        }
    })
}

/**
 * 发送短信验证码
 * @param {Object} params 接口参数
 * @return {Promise}
 */
export function sendSMSCaptcha(params) {
    return request.post({ url: SERVICE_SEND_SMS_CAPTCHA, data: params})
}

export function getToken() {
    return request.get({ url: '/auth/token' })
}
